import React from 'react';
import './Header.css';

const Header = ({ company }) => {
  return (
    <div className="companyProfileHeader">
      <span className="logoContainerWrapper">
        <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 18 18" fill="none">
          <path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333"/>
          <path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333"/>
          <path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333"/>
        </svg>
      </span>
      <h1 className="companyName">
        {company.company_name}
      </h1>
      <p className="descriptionText">
        {company.company_description}
      </p>
      <div className="companyDetails">
        <div className="marketValue">
          <h3>Market Value</h3>
          <span>{company.company_market_value}</span>
        </div>
        <div className="shareholders">
          <h3>Shareholders</h3>
          <ul>
            {company.company_shareholders.split(',').map((shareholder, index, array) => (
              <React.Fragment key={index}>
                <li>{shareholder.trim()}</li>
                {index < array.length - 1 && <li className="separator">|</li>}
              </React.Fragment>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Header; 